import {styled, TableCell} from "@mui/material";

export const LocationTableCell = styled(TableCell)(() => ({
    padding: '0.2rem 1rem',

    '& .MuiTableCell-body': {
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center'
    }
}));